import React from 'react';
import { useTranslation } from 'react-i18next';
import GenericTablePage from '../components/GenericTablePage';
import { GridColDef } from '@mui/x-data-grid';

const BoardAttachmentsPage: React.FC = () => {
  const { t } = useTranslation();

  const columns: GridColDef[] = [
    { field: 'meeting_no', headerName: t('boardMeetings.meetingNo'), width: 120 },
    { field: 'filename', headerName: t('boardAttachments.filename'), flex: 1, minWidth: 240 },
    {
      field: 'file_url',
      headerName: t('boardAttachments.file'),
      width: 120,
      sortable: false,
      renderCell: (params) =>
        params.value ? (
          <a href={params.value} target="_blank" rel="noopener noreferrer">
            {t('boardAttachments.open')}
          </a>
        ) : null,
    },
  ];

  const fields = [
    {
      name: 'meeting_id',
      label: t('boardAttachments.meeting'),
      required: true,
      width: 'half' as const,
      foreignKey: { table: 'board_meetings', valueField: 'id', labelField: 'meeting_no,date' },
    },
    { name: 'meeting_no', label: t('boardMeetings.meetingNo'), type: 'text' as const, width: 'half' as const },
    { name: 'filename', label: t('boardAttachments.filename'), type: 'text' as const, width: 'full' as const },
    {
      name: 'file_url',
      label: t('boardAttachments.file'),
      type: 'file' as const,
      bucket: 'board-minutes',
      accept: 'application/pdf',
      width: 'full' as const,
    },
  ];

  return (
    <GenericTablePage
      tableName="board_attachments"
      title={t('boardAttachments.title')}
      columns={columns}
      fields={fields}
    />
  );
};

export default BoardAttachmentsPage;
